import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights,
}: Theme) => ({
  paper: {
    '&&': {
      width: '20.5rem',
      maxWidth: '100%',
      padding: '2rem 0',
      [breakpoints.up('md')]: {
        width: '31.25rem',
        padding: '3rem 0',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    '&&': {
      padding: '0 1rem',
      [breakpoints.up('md')]: {
        padding: '0 3rem',
      },
    },
  },
  title: {
    margin: '0 0 2rem',
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.33,
    },
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
  },
  firstField: {
    height: '7rem',
  },
  secondField: {
    height: '4rem',
    marginBottom: '2rem',
  },
  submitButton: {
    width: '16.8125rem',
    height: '3rem',
  },
}));